import { Star } from "lucide-react";
import { REVIEWS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const AVATAR_BG = ["bg-xmove-orange", "bg-xmove-night", "bg-xmove-green", "bg-[#B45309]", "bg-[#0E7490]", "bg-[#7C3A0E]"];

export const Reviews = ({ limit = 6 }) => (
  <section className="bg-white py-16 lg:py-24" data-testid="reviews">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-xmove-orange">Recensioni Google</p>
            <h2 className="mt-3 font-display text-3xl font-bold text-xmove-ink sm:text-4xl">Chi ci ha scelto, parla chiaro</h2>
          </div>
          <div className="flex items-center gap-2 rounded-full border border-xmove-ink/10 bg-xmove-cream px-4 py-2">
            <span className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={15} className="fill-xmove-green text-xmove-green" />
              ))}
            </span>
            <span className="text-sm font-bold text-xmove-ink">5.0</span>
            <span className="text-xs text-xmove-muted">su Google</span>
          </div>
        </div>
      </Reveal>
      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {REVIEWS.slice(0, limit).map((r, i) => (
          <Reveal key={r.name} delay={(i % 3) * 0.08} className="h-full">
            <figure className="flex h-full flex-col rounded-2xl border border-xmove-ink/8 bg-xmove-cream p-6">
              <span className="flex" aria-label="5 stelle">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={14} className="fill-xmove-green text-xmove-green" />
                ))}
              </span>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-xmove-ink/90">“{r.text}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-xmove-ink/8 pt-4">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full text-xs font-bold text-white ${AVATAR_BG[i % AVATAR_BG.length]}`}>
                  {r.initials}
                </span>
                <span>
                  <span className="block text-sm font-bold text-xmove-ink">{r.name}</span>
                  <span className="block text-xs text-xmove-muted">{r.role}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
